import { render, staticRenderFns } from "./UnoForm.vue?vue&type=template&id=1b2e7a8b&"
import script from "./UnoForm.vue?vue&type=script&lang=js&"
export * from "./UnoForm.vue?vue&type=script&lang=js&"
import style0 from "./UnoForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports